import api from './axios';
import { 
  Campaign, 
  CreateCampaignRequest, 
  UpdateCampaignRequest, 
  PaginatedResponse,
  ApiResponse,
  CampaignStatus
} from '../types';

export class CampaignsService {
  async getCampaigns(
    page = 1, 
    limit = 10, 
    search?: string, 
    status?: CampaignStatus,
    ownerId?: string
  ): Promise<PaginatedResponse<Campaign>> {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    
    if (search) params.append('search', search);
    if (status) params.append('status', status);
    if (ownerId) params.append('ownerId', ownerId);
    
    const response = await api.get<PaginatedResponse<Campaign>>(`/api/v1/campaigns?${params}`);
    return response.data;
  }

  async getCampaignById(id: string): Promise<Campaign> {
    const response = await api.get<ApiResponse<Campaign>>(`/api/v1/campaigns/${id}`);
    return response.data.data;
  }

  async createCampaign(campaignData: CreateCampaignRequest): Promise<Campaign> {
    const response = await api.post<ApiResponse<Campaign>>('/api/v1/campaigns', campaignData);
    return response.data.data;
  }

  async updateCampaign(campaignData: UpdateCampaignRequest): Promise<Campaign> {
    const { id, ...updateData } = campaignData;
    const response = await api.put<ApiResponse<Campaign>>(`/api/v1/campaigns/${id}`, updateData);
    return response.data.data;
  }

  async deleteCampaign(id: string): Promise<void> {
    await api.delete(`/api/v1/campaigns/${id}`);
  }

  async updateCampaignStatus(id: string, status: CampaignStatus): Promise<Campaign> {
    const response = await api.patch<ApiResponse<Campaign>>(`/api/v1/campaigns/${id}/status`, { status });
    return response.data.data;
  }

  async duplicateCampaign(id: string, newName: string): Promise<Campaign> {
    const response = await api.post<ApiResponse<Campaign>>(`/api/v1/campaigns/${id}/duplicate`, { name: newName });
    return response.data.data;
  }
}

export const campaignsService = new CampaignsService();
